<template>
    <div id="knowledge-base-category-page">
        <h2 class="mb-4">{{ categoryTitle }}</h2>
        <p class="mb-4">{{ categorySubtitle }}</p>

        <div class="vx-row mt-8 match-height">
            <div class="vx-col w-full sm:w-1/2 md:w-1/3 mb-base" v-for="section in sections" :key="section.id">
                <vx-card>
                    <h4 class="mb-4">{{ section.title }}</h4>
                    <ul class="bordered-items">
                        <li v-for="que in section.questions" :key="que.question" class="py-2"><router-link :to="que.answerUrl">{{ que.question }}</router-link></li>
                    </ul>
                </vx-card>
            </div>
        </div>
    </div>
</template>

<script>

export default{
    data() {
        return {
            categoryTitle: 'Todas as Categorias',
            categorySubtitle: 'aqui você encontra todas as suas dúvidas referente ao ' + process.env.VUE_APP_NAME + '.',
            sections: [
                {
                    "id": 0,
                    "title": 'Instalação',
                    "questions": [
                    {
                        "id": 0,
                        "question": 'Como instalar no celular Samsung?',
                        "answerUrl": "/pages/suporte/categoria/pergunta"
                    },
                    {
                        "id": 1,
                        "question": 'Como deixar oculto?',
                        "answerUrl": "/pages/suporte/categoria/pergunta"
                    },
                    ]
                },
                {
                    "id": 1,
                    "title": 'Erros',
                    "questions": [
                    {
                        "id": 0,
                        "question": 'Perguntou se posso ativar a acessibilidade?',
                        "answerUrl": "/pages/suporte/categoria/pergunta"
                    },
                    {
                        "id": 1,
                        "question": 'Posso ativar a sobreposição?',
                        "answerUrl": "/pages/suporte/categoria/pergunta"
                    },
                    ]
                },
            ]
        }
    },
    computed: {
    },
    methods: {},
    components: {},
    mounted() {
        this.$emit('changeRouteTitle', 'Category');
    }
}
</script>
